import { Pipe, PipeTransform } from '@angular/core';
import { when } from 'src/app/modules/when';
import { InstructionStatus } from 'src/models/pci';

@Pipe({ name: 'reservation_status' })
export class ReservationStatusPipe implements PipeTransform {
  transform(value: any, ...args: any[]) {
    return when(value)
      .on(
        v => v === InstructionStatus.requested,
        _ => '未確認',
      )
      .on(
        v => v === InstructionStatus.confirmed,
        _ => '確定',
      )
      .on(
        v => v === InstructionStatus.completed,
        _ => '服薬指導完了済み',
      )
      .on(
        v => v === InstructionStatus.incomplete,
        _ => '服薬指導実施不可能',
      )
      .on(
        v => v === InstructionStatus.withdrawn,
        _ => '取り下げ',
      )
      .on(
        v => v === InstructionStatus.cancelled_by_patient,
        _ => '患者からのキャンセル',
      )
      .on(
        v => v === InstructionStatus.cancelled_by_pharmacist,
        _ => '薬剤師によるキャンセル',
      )
      .on(
        v => v === InstructionStatus.declined,
        _ => 'お断り',
      )
      .on(
        v => v === InstructionStatus.meeting_performed,
        _ => '服薬指導実施済み',
      )
      .on(
        v => v === InstructionStatus.meeting_completed,
        _ => '服薬指導完了',
      )
      .otherwise(_ => '不明');
  }
}
